import axios, { endpoints } from 'src/utils/axios';

import { setSession } from './utils';

import { getDeviceId } from 'src/utils/getDeviceId';

export type SignInParams = {
  username: string;
  password: string;
  force_login?: boolean;
};

export const signInWithPassword = async ({ username, password, force_login }: SignInParams): Promise<any> => {
  try {
    const device_id = getDeviceId();
    const params = { username, password, device_id, force_login };

    const res = await axios.post(endpoints.auth.signIn, params);

    // Nếu thiết bị bị pending (202 Accepted)
    if (res.data?.status === 'PENDING_APPROVAL') {
      return res.data;
    }

    // Đón access_token từ API mới
    const token = res.data.access_token || res.data.token;

    if (!token) {
      throw new Error('Access token not found in response');
    }

    await setSession(token);
    return res.data;
  } catch (error: any) {
    console.error('Error during sign in:', error);
    // Để logic form bắt lỗi 409
    throw error;
  }
};
export const signOut = async (): Promise<void> => {
  try {
    await axios.get(endpoints.auth.logOut);
    await setSession(null);
  } catch (error) {
    console.error('Error during sign out:', error.message);
    throw error;
  }
};
